// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"599b0b3b","453":"d6ecab7d","455":"f156cdc1"}[chunkId] + ".chunk.js";
};